module.exports = __webpack_public_path__ + "img/remover-dependente-rounded.43b4d2da.svg";